import React from 'react'
import {View, Text, StyleSheet, TouchableOpacity} from 'react-native'

type Props = {
  onSignOut: Function,
}

export const SettingsMenu = ({onSignOut}: Props) => (
  <View
    style={styles.settingsMenu}
  >
    <TouchableOpacity
      onPress={onSignOut}
    >
      <Text
        style={styles.signOut}
      >
        Sign Out
      </Text>
    </TouchableOpacity>
  </View>
)

const styles = StyleSheet.create({
  settingsMenu: {
    display: 'flex',
    justifyContent: 'center',
    height: 100,
    width: '100%',
  },
  signOut: {
    marginLeft: 160,
    marginTop: 40,
    marginBottom: 0,
    fontWeight: 'bold',
  },
})